import { render, staticRenderFns } from "./HeadingSection.vue?vue&type=template&id=43f25c56&scoped=true&"
import script from "./HeadingSection.vue?vue&type=script&lang=js&"
export * from "./HeadingSection.vue?vue&type=script&lang=js&"
import style0 from "./HeadingSection.vue?vue&type=style&index=0&id=43f25c56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f25c56",
  null
  
)

export default component.exports